import {NotesFormSchema} from '@/features/projects/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const NotesFormProvider = ({
    children,
    defaultValues
}: {
    children: ReactNode
    defaultValues?: NotesFormSchema
}) => {
    const form = useForm<NotesFormSchema>({
        mode: 'onBlur',
        resolver: zodResolver(NotesFormSchema),
        defaultValues: defaultValues
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
